import { render } from "./Index.vue?vue&type=template&id=8cbc9204&scoped=true&ts=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=8cbc9204&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cbc9204"]])

export default __exports__